
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'Hizmetler', path: '/hizmetler' },
    { name: 'İletişim', path: '/iletisim' },
  ];

  // Anasayfa dışındaki tüm sayfalarda menü her zaman koyu renk olacak
  const isHomePage = location.pathname === '/';

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled || !isHomePage
            ? 'bg-white/95 backdrop-blur-md shadow-lg'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between h-24 lg:h-28">
            {/* Logo - Sol üst köşe */}
            <Link 
              to="/" 
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex-shrink-0 z-50"
            >
              <img
                src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/cd057c2c8fd44e35a555ddce864c0bba.png"
                alt="Bursa Sulama Sistemleri"
                className="h-16 lg:h-20 w-auto"
              />
            </Link>

            {/* Desktop Navigation - Ortada */}
            <div className="hidden lg:flex items-center gap-8 absolute left-1/2 transform -translate-x-1/2">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className={`text-lg font-medium transition-colors whitespace-nowrap ${
                    location.pathname === link.path
                      ? 'text-[#14B8A6]'
                      : isScrolled || !isHomePage
                      ? 'text-[#0A1628] hover:text-[#14B8A6]'
                      : 'text-white hover:text-[#14B8A6]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
            </div>

            {/* Phone Button - Sağda */}
            <a
              href="tel:+905071344668"
              className="hidden lg:flex items-center gap-3 bg-[#14B8A6] hover:bg-[#0F9B8E] text-white px-8 py-4 rounded-full transition-all duration-300 hover:scale-105 shadow-lg whitespace-nowrap"
            >
              <i className="ri-phone-fill text-xl"></i>
              <span className="font-semibold">0507 134 46 68</span>
            </a>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden p-2 rounded-lg z-50"
              aria-label="Menü"
            >
              <i
                className={`text-2xl ${
                  isMobileMenuOpen || !isHomePage || isScrolled
                    ? 'text-[#0A1628]' 
                    : 'text-white'
                } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 bg-white z-40 pt-24">
          <div className="flex flex-col h-full">
            <div className="px-6 py-4 space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className={`block py-3 px-4 rounded-lg text-base font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'bg-[#14B8A6] text-white'
                      : 'text-[#0A1628] hover:bg-gray-100'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:+905071344668"
                className="flex items-center justify-center gap-3 bg-[#14B8A6] text-white px-6 py-4 rounded-full font-semibold whitespace-nowrap"
              >
                <i className="ri-phone-fill text-xl"></i>
                <span>0507 134 46 68</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
